import { Context } from "@nuxt/types/app";

import getBase64toBlob from "./file.base64toBlob.plugin";
import getBlobCSV from "./file.blobCSV.plugin";
import getBlobExcel from "./file.blobExcel.plugin";
import getDataURItoBlob from "./file.dataURItoBlob.plugin";
import geFiletoBase64 from "./file.filetoBase64.plugin";
import getGetExtensionFromType from "./file.getExtensionFromType.plugin";
import getGetSelectedFilesInfo from "./file.getSelectedFilesInfo.plugin";
import getGetTypeFromFileType from "./file.getTypeFromFileType.plugin";
import getIsImage from "./file.isImage.plugin";
import getIsVideo from "./file.isVideo.plugin";

export function filePlugin(context: Context) {
  const { filetoBase64 } = geFiletoBase64(context);
  const { base64toBlob } = getBase64toBlob(context);
  const { getSelectedFilesInfo } = getGetSelectedFilesInfo(context);
  const { getExtensionFromType } = getGetExtensionFromType(context);
  const { getTypeFromFileType } = getGetTypeFromFileType(context);
  const { blobExcel } = getBlobExcel(context);
  const { blobCSV } = getBlobCSV(context);
  const { dataURItoBlob } = getDataURItoBlob(context);
  const { isImage } = getIsImage(context);
  const { isVideo } = getIsVideo(context);

  return {
    filetoBase64,
    base64toBlob,
    getSelectedFilesInfo,
    getExtensionFromType,
    getTypeFromFileType,
    blobExcel,
    blobCSV,
    dataURItoBlob,
    isImage,
    isVideo,
  };
}
